"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSuggestedIssuers = getSuggestedIssuers;
var DEFAULT_ISSUERS = [
    {
        name: 'Solid Community',
        uri: 'https://solidcommunity.net'
    },
    {
        name: 'Solid Web',
        uri: 'https://solidweb.org'
    },
    {
        name: 'Inrupt.net',
        uri: 'https://inrupt.net'
    },
    {
        name: 'pod.Inrupt.com',
        uri: 'https://login.inrupt.com'
    }
];
/**
 * @returns - A list of suggested OIDC issuers
 */
function getSuggestedIssuers() {
    // Suggest a default list of OIDC issuers
    var issuers = __spreadArray([], DEFAULT_ISSUERS, true);
    // Suggest the current host if not already included
    var _a = new URL(location.href), host = _a.host, origin = _a.origin;
    var hosts = issuers.map(function (_a) {
        var uri = _a.uri;
        return new URL(uri).host;
    });
    if (!hosts.includes(host) && !hosts.some(function (existing) { return isSubdomainOf(host, existing); })) {
        issuers.unshift({ name: host, uri: origin });
    }
    return issuers;
}
function isSubdomainOf(subdomain, domain) {
    var dot = subdomain.length - domain.length - 1;
    return dot > 0 && subdomain[dot] === '.' && subdomain.endsWith(domain);
}
//# sourceMappingURL=issuerLogic.js.map